{
  "editMode_deleteButtonAriaLabel": "Slett"
}
